/* Sommaire numéroté (bloc nky-sommaire, 31/10/2026) : le bouton déplie ou replie les éléments au-delà des « visibles ».
   Chargé par chaque sommaire : ne s'installe qu'une fois (délégation sur document, éditeur compris). */
(function () {
  if (window.nkySommaire) return;
  window.nkySommaire = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nky-sommaire-plus]');
    if (!b) return;
    var s = b.closest('[data-nky-sommaire]');
    var ouvert = !s.hasAttribute('data-ouvert');
    s.toggleAttribute('data-ouvert', ouvert);
    b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    b.textContent = ouvert ? (b.dataset.moins || b.dataset.plus) : b.dataset.plus;
    if (!ouvert) s.scrollIntoView({ block: 'nearest' });
  });
})();
